// Фиксированный набор переменных для всех шаблонов документов.
// Эти переменные используются в API и не могут быть изменены пользователями.

export const TEMPLATE_VARIABLES = {
  // Общие данные
  'contract_number': 'Номер договора',
  'contract_date': 'Дата заключения договора',
  'current_date': 'Текущая дата',
  'city': 'Город заключения договора',
  'agreement_date': 'Дата заключения соглашения',
  'kommersant_party_kind': 'Коммерсантъ: кто оплачивает / на кого оформляются документы (debtor/organizer/manager)',
  'kommersant_party_name': 'Коммерсантъ: наименование выбранной стороны',
  'kommersant_party_name_r': 'Коммерсантъ: наименование выбранной стороны (род. падеж - кого? чего?)',
  'kommersant_party_name_d': 'Коммерсантъ: наименование выбранной стороны (дат. падеж - кому? чему?)',
  'kommersant_party_name_v': 'Коммерсантъ: наименование выбранной стороны (вин. падеж - кого? что?)',
  'kommersant_party_name_t': 'Коммерсантъ: наименование выбранной стороны (тв. падеж - кем? чем?)',
  'kommersant_party_name_p': 'Коммерсантъ: наименование выбранной стороны (пр. падеж - о ком? о чём?)',

  // Должник
  'debtor_name': 'Наименование должника',
  'debtor_name_r': 'Наименование должника (род. падеж - кого? чего?)',
  'debtor_name_d': 'Наименование должника (дат. падеж - кому? чему?)',
  'debtor_name_v': 'Наименование должника (вин. падеж - кого? что?)',
  'debtor_name_t': 'Наименование должника (тв. падеж - кем? чем?)',
  'debtor_name_p': 'Наименование должника (пр. падеж - о ком? о чём?)',
  'debtor_gender': 'Пол должника для IF (male/female/neuter/unknown)',
  'debtor_type': 'Тип должника (юридическое лицо, ИП, физическое лицо)',
  'debtor_legal_form': 'Организационно-правовая форма должника',
  'debtor_inn': 'ИНН должника',
  'debtor_kpp': 'КПП должника',
  'debtor_ogrn': 'ОГРН должника',
  'debtor_snils': 'СНИЛС должника',
  'debtor_address': 'Адрес должника',
  'debtor_email': 'Email должника',
  'debtor_phone': 'Телефон должника',
  'debtor_case_number': 'Номер дела о банкротстве',
  'debtor_arbitration_court': 'Арбитражный суд',
  'debtor_case_act_court': 'Суд, вынесший акт о введении процедуры',
  'debtor_manager_act_court': 'Суд, вынесший акт о назначении управляющего',
  'debtor_procedure': 'Процедура (например: конкурсного производства)',
  'debtor_manager_role': 'Тип управляющего (врем., конк., админ.,внеш.,фин.)',
  'debtor_manager_role_r': 'Тип управляющего (род. падеж - кого? чего?)',
  'debtor_manager_role_d': 'Тип управляющего (дат. падеж - кому? чему?)',
  'debtor_manager_role_v': 'Тип управляющего (вин. падеж - кого? что?)',
  'debtor_manager_role_t': 'Тип управляющего (тв. падеж - кем? чем?)',
  'debtor_manager_role_p': 'Тип управляющего (пр. падеж - о ком? о чём?)',
  'debtor_manager_gender': 'Пол арбитражного управляющего для IF (male/female/neuter/unknown)',
  'debtor_case_act_date': 'Дата судебного акта о введении процедуры',
  'debtor_case_act_type': 'Тип судебного акта о введении процедуры',
  'debtor_case_act_type_r': 'Тип судебного акта о введении процедуры (род. падеж - кого? чего?)',
  'debtor_case_act_type_d': 'Тип судебного акта о введении процедуры (дат. падеж - кому? чему?)',
  'debtor_case_act_type_v': 'Тип судебного акта о введении процедуры (вин. падеж - кого? что?)',
  'debtor_case_act_type_t': 'Тип судебного акта о введении процедуры (тв. падеж - кем? чем?)',
  'debtor_case_act_type_p': 'Тип судебного акта о введении процедуры (пр. падеж - о ком? о чём?)',
  'debtor_manager_act_date': 'Дата судебного акта о назначении управляющего',
  'debtor_manager_act_type': 'Тип судебного акта о назначении управляющего',
  'debtor_manager_act_type_r': 'Тип судебного акта о назначении управляющего (род. падеж - кого? чего?)',
  'debtor_manager_act_type_d': 'Тип судебного акта о назначении управляющего (дат. падеж - кому? чему?)',
  'debtor_manager_act_type_v': 'Тип судебного акта о назначении управляющего (вин. падеж - кого? что?)',
  'debtor_manager_act_type_t': 'Тип судебного акта о назначении управляющего (тв. падеж - кем? чем?)',
  'debtor_manager_act_type_p': 'Тип судебного акта о назначении управляющего (пр. падеж - о ком? о чём?)',
  'debtor_manager_name': 'ФИО арбитражного управляющего должника',
  'debtor_manager_name_short': 'Фамилия и инициалы арбитражного управляющего (Фамилия И.О.)',
  'debtor_manager_name_short_r': 'Фамилия и инициалы арбитражного управляющего (род. падеж - кого? чего?)',
  'debtor_manager_name_short_d': 'Фамилия и инициалы арбитражного управляющего (дат. падеж - кому? чему?)',
  'debtor_manager_name_short_v': 'Фамилия и инициалы арбитражного управляющего (вин. падеж - кого? что?)',
  'debtor_manager_name_short_t': 'Фамилия и инициалы арбитражного управляющего (тв. падеж - кем? чем?)',
  'debtor_manager_name_short_p': 'Фамилия и инициалы арбитражного управляющего (пр. падеж - о ком? о чём?)',
  'debtor_manager_name_r': 'ФИО арбитражного управляющего (род. падеж - кого? чего?)',
  'debtor_manager_name_d': 'ФИО арбитражного управляющего (дат. падеж - кому? чему?)',
  'debtor_manager_name_v': 'ФИО арбитражного управляющего (вин. падеж - кого? что?)',
  'debtor_manager_name_t': 'ФИО арбитражного управляющего (тв. падеж - кем? чем?)',
  'debtor_manager_name_p': 'ФИО арбитражного управляющего (пр. падеж - о ком? о чём?)',
  'debtor_manager_inn': 'ИНН арбитражного управляющего должника',
  'debtor_manager_snils': 'СНИЛС арбитражного управляющего должника',
  'debtor_manager_sro_info': 'Сведения о СРО арбитражного управляющего должника',
  'debtor_manager_sro_name': 'СРО арбитражного управляющего должника — наименование',
  'debtor_manager_sro_name_r': 'СРО арбитражного управляющего должника — наименование (род. падеж - кого? чего?)',
  'debtor_manager_sro_name_d': 'СРО арбитражного управляющего должника — наименование (дат. падеж - кому? чему?)',
  'debtor_manager_sro_name_v': 'СРО арбитражного управляющего должника — наименование (вин. падеж - кого? что?)',
  'debtor_manager_sro_name_t': 'СРО арбитражного управляющего должника — наименование (тв. падеж - кем? чем?)',
  'debtor_manager_sro_name_p': 'СРО арбитражного управляющего должника — наименование (пр. падеж - о ком? о чём?)',
  'debtor_manager_sro_inn': 'СРО арбитражного управляющего должника — ИНН',
  'debtor_manager_sro_ogrn': 'СРО арбитражного управляющего должника — ОГРН',
  'debtor_manager_sro_address': 'СРО арбитражного управляющего должника — адрес',
  'debtor_manager_phone': 'Телефон арбитражного управляющего должника',
  'debtor_manager_email': 'Email арбитражного управляющего должника',
  'debtor_manager_mailing_address': 'Адрес для корреспонденции арбитражного управляющего должника',

  // Организатор торгов
  'organizer_name': 'Наименование организатора торгов',
  'organizer_name_r': 'Наименование организатора (род. падеж - кого? чего?)',
  'organizer_name_d': 'Наименование организатора (дат. падеж - кому? чему?)',
  'organizer_name_v': 'Наименование организатора (вин. падеж - кого? что?)',
  'organizer_name_t': 'Наименование организатора (тв. падеж - кем? чем?)',
  'organizer_name_p': 'Наименование организатора (пр. падеж - о ком? о чём?)',
  'organizer_type': 'Тип организатора (арбитражный управляющий, спецорганизация)',
  'organizer_entity_type': 'Тип организатора (ЮЛ/ИП/ФЛ)',
  'organizer_inn': 'ИНН организатора торгов',
  'organizer_ogrn': 'ОГРН/ОГРНИП организатора торгов',
  'organizer_kpp': 'КПП организатора торгов',
  'organizer_address': 'Адрес организатора торгов',
  'organizer_mailing_address': 'Адрес для корреспонденции организатора',
  'organizer_phone': 'Телефон организатора торгов',
  'organizer_email': 'Email организатора торгов',
  'organizer_contacts': 'Контактная информация организатора',
  'organizer_details': 'Полные реквизиты организатора',
  'organizer_executive_role': 'ЕИО (должность подписанта организатора)',
  'organizer_executive_name': 'ЕИО (ФИО подписанта организатора)',
  'organizer_snils': 'СНИЛС организатора (для арбитражных управляющих)',

  // Арбитражный управляющий / подписант
  'organizer_signatory': 'ФИО подписанта от организатора',
  'organizer_signatory_r': 'ФИО подписанта (род. падеж - кого? чего?)',
  'organizer_signatory_d': 'ФИО подписанта (дат. падеж - кому? чему?)',
  'organizer_signatory_v': 'ФИО подписанта (вин. падеж - кого? что?)',
  'organizer_signatory_t': 'ФИО подписанта (тв. падеж - кем? чем?)',
  'organizer_signatory_p': 'ФИО подписанта (пр. падеж - о ком? о чём?)',

  // Покупатель
  'buyer_name': 'ФИО или наименование покупателя',
  'buyer_details': 'Реквизиты покупателя',

  // Продавец
  'seller_name': 'ФИО или наименование продавца',
  'seller_details': 'Реквизиты продавца',

  // Участник торгов
  'participant_name': 'ФИО или наименование участника торгов',
  'participant_details': 'Полные реквизиты участника',

  // Лоты и имущество
  'property_description': 'Описание имущества',
  'property_lots': 'Описание лотов с начальными ценами',
  'property_lots_desc_lines': 'Описание лотов (описание, цена, НДС)',
  'lot_number': 'Номер лота (если один)',
  'pledge_lots_count': 'Количество лотов с залоговыми кредиторами (число)',
  'pledge_lots_single_creditor_total_count': 'Количество залоговых лотов с одним кредитором (число)',
  'pledge_lots_single_creditor_unique_count': 'Количество уникальных кредиторов (только лоты с одним кредитором)',
  'pledge_single_creditor_groups': 'Группы залоговых лотов с одним кредитором (для цикла)',
  'pledge_single_creditor_solo_lots': 'Залоговые лоты с одним кредитором (по одному) — для цикла',
  'pledge_multi_creditor_entries': 'Лоты с несколькими кредиторами (по кредитору) — для цикла',

  // Параметры торгов
  'auction_form': 'Тип торгов (аукцион/конкурс/публичное предложение)',
  'auction_trade_form': 'Форма торгов (Открытая/Закрытая)',
  'auction_trade_form_text': 'Тип и форма подачи предложений (комбинированно: тип/подача)',
  'auction_type': 'Форма подачи предложений (открытая/закрытая)',
  'auction_lots_count': 'Количество лотов (число)',
  'auction_date': 'Дата проведения торгов',
  'auction_start_datetime': 'Дата и время начала торгов',
  'application_start_datetime': 'Дата и время начала приема заявок',
  'application_deadline': 'Дата и время окончания приема заявок',
  'results_datetime': 'Дата и время подведения итогов',
  'auction_location': 'Место проведения торгов',
  'etp_name': 'Наименование ЭТП',
  'etp_site': 'Сайт ЭТП',
  'etp_operator': 'Оператор ЭТП',
  'application_procedure': 'Порядок подачи заявок',
  'auction_step': 'Шаг аукциона (в процентах)',
  'contest_step': 'Шаг конкурса (в процентах)',
  'price_decrease_rules': 'Порядок снижения цены (для публичного предложения)',
  'contest_conditions': 'Условия проведения конкурса',

  // Финансовые условия
  'price': 'Цена имущества (цифрами)',
  'price_text': 'Цена имущества (прописью)',
  'deposit_amount': 'Размер задатка (в процентах)',
  'deposit_amount_text': 'Размер задатка (прописью)',
  'deposit_percent': 'Размер задатка в процентах',
  'deposit_deadline': 'Крайний срок внесения задатка',
  'deposit_bank_details': 'Банковские реквизиты для задатка',
  'payment_period': 'Срок оплаты (в днях)',
  'transfer_period': 'Срок передачи имущества (в днях)',

  // Банковские реквизиты
  'bank_details': 'Банковские реквизиты',
  'deposit_account_details': 'Реквизиты счета для внесения задатка',
  'payment_account_details': 'Реквизиты счета для оплаты по договору',
  'deposit_account_owner_name': 'Наименование владельца счета для внесения задатка',
  'payment_account_owner_name': 'Наименование владельца счета для оплаты по договору',
  'deposit_account_owner_inn': 'ИНН владельца счета для внесения задатка',
  'payment_account_owner_inn': 'ИНН владельца счета для оплаты по договору',
  'deposit_account_owner_type_code': 'Тип владельца счета для внесения задатка (debtor/organizer/platform)',
  'payment_account_owner_type_code': 'Тип владельца счета для оплаты по договору (debtor/organizer/platform)',
  'deposit_account_owner_type_label': 'Тип владельца счета для внесения задатка (человекочитаемо)',
  'payment_account_owner_type_label': 'Тип владельца счета для оплаты по договору (человекочитаемо)',
  'deposit_account_owner_type_label_r': 'Тип владельца счета для внесения задатка (род. падеж - кого? чего?)',
  'deposit_account_owner_type_label_d': 'Тип владельца счета для внесения задатка (дат. падеж - кому? чему?)',
  'deposit_account_owner_type_label_v': 'Тип владельца счета для внесения задатка (вин. падеж - кого? что?)',
  'deposit_account_owner_type_label_t': 'Тип владельца счета для внесения задатка (тв. падеж - кем? чем?)',
  'deposit_account_owner_type_label_p': 'Тип владельца счета для внесения задатка (пр. падеж - о ком? о чём?)',
  'payment_account_owner_type_label_r': 'Тип владельца счета для оплаты по договору (род. падеж - кого? чего?)',
  'payment_account_owner_type_label_d': 'Тип владельца счета для оплаты по договору (дат. падеж - кому? чему?)',
  'payment_account_owner_type_label_v': 'Тип владельца счета для оплаты по договору (вин. падеж - кого? что?)',
  'payment_account_owner_type_label_t': 'Тип владельца счета для оплаты по договору (тв. падеж - кем? чем?)',
  'payment_account_owner_type_label_p': 'Тип владельца счета для оплаты по договору (пр. падеж - о ком? о чём?)',

  // Контакты
  'documentation_address': 'Адрес для ознакомления с документами',
  'working_hours': 'Часы работы',
  'contact_person': 'Контактное лицо',
  'inspection_phone': 'Телефон для ознакомления',
  'inspection_email': 'Email для ознакомления',
  'contact_phone': 'Контактный телефон'
};

// Группировка переменных для удобства отображения
export const VARIABLE_GROUPS = {
  'Общие данные': [
    'contract_number',
    'contract_date',
    'current_date',
    'city',
    'agreement_date'
  ],
  'Коммерсантъ': [
    'kommersant_party_kind',
    'kommersant_party_name'
  ],
  'Должник': [
    'debtor_name',
    'debtor_gender',
    'debtor_type',
    'debtor_legal_form',
    'debtor_inn',
    'debtor_kpp',
    'debtor_ogrn',
    'debtor_snils',
    'debtor_address',
    'debtor_email',
    'debtor_phone',
    'debtor_case_number',
    'debtor_arbitration_court',
    'debtor_case_act_court',
    'debtor_manager_act_court',
    'debtor_procedure',
    'debtor_case_act_date',
    'debtor_case_act_type',
    'debtor_manager_act_date',
    'debtor_manager_act_type'
  ],
  'Арбитражный управляющий должника': [
    'debtor_manager_role',
    'debtor_manager_gender',
    'debtor_manager_name',
    'debtor_manager_name_short',
    'debtor_manager_name_short_r',
    'debtor_manager_name_short_d',
    'debtor_manager_name_short_v',
    'debtor_manager_name_short_t',
    'debtor_manager_name_short_p',
    'debtor_manager_inn',
    'debtor_manager_snils',
    'debtor_manager_sro_info',
    'debtor_manager_sro_name',
    'debtor_manager_sro_inn',
    'debtor_manager_sro_ogrn',
    'debtor_manager_sro_address',
    'debtor_manager_phone',
    'debtor_manager_email',
    'debtor_manager_mailing_address'
  ],
  'Организатор торгов': [
    'organizer_name',
    'organizer_type',
    'organizer_entity_type',
    'organizer_inn',
    'organizer_ogrn',
    'organizer_kpp',
    'organizer_address',
    'organizer_mailing_address',
    'organizer_phone',
    'organizer_email',
    'organizer_contacts',
    'organizer_details'
  ],
  'Арбитражный управляющий / подписант': [
    'organizer_executive_role',
    'organizer_executive_name',
    'organizer_signatory',
    'organizer_snils'
  ],
  'Покупатель': [
    'buyer_name',
    'buyer_details'
  ],
  'Продавец': [
    'seller_name',
    'seller_details'
  ],
  'Участник торгов': [
    'participant_name',
    'participant_details'
  ],
  'Лоты и имущество': [
    'property_description',
  'property_lots',
  'property_lots_desc_lines',
  'lot_number',
    'pledge_lots_count',
    'pledge_lots_single_creditor_total_count',
    'pledge_lots_single_creditor_unique_count',
    'pledge_single_creditor_groups',
    'pledge_single_creditor_solo_lots',
    'pledge_multi_creditor_entries'
  ],
  'Параметры торгов': [
    'auction_form',
    'auction_trade_form',
    'auction_trade_form_text',
    'auction_type',
    'auction_lots_count',
    'auction_date',
    'auction_start_datetime',
    'application_start_datetime',
    'application_deadline',
    'results_datetime',
    'auction_location',
    'etp_name',
    'etp_site',
    'etp_operator',
    'application_procedure',
    'auction_step',
    'contest_step',
    'price_decrease_rules',
    'contest_conditions'
  ],
  'Финансовые условия': [
    'price',
    'price_text',
    'deposit_amount',
    'deposit_amount_text',
    'deposit_percent',
    'deposit_deadline',
    'deposit_bank_details',
    'payment_period',
    'transfer_period'
  ],
  'Банковские реквизиты': [
    'bank_details',
    'deposit_account_details',
    'payment_account_details',
    'deposit_account_owner_name',
    'payment_account_owner_name',
    'deposit_account_owner_inn',
    'payment_account_owner_inn',
    'deposit_account_owner_type_code',
    'payment_account_owner_type_code',
    'deposit_account_owner_type_label',
    'payment_account_owner_type_label'
  ],
  'Контакты': [
    'documentation_address',
    'working_hours',
    'contact_person',
    'inspection_phone',
    'inspection_email',
    'contact_phone'
  ]
};

// Переменные, которые являются ФИО и требуют выбора падежа
export const NAME_VARIABLES = [
  'debtor_name',
  'debtor_manager_name',
  'debtor_manager_name_short',
  'debtor_manager_sro_name',
  'organizer_name', 
  'organizer_signatory',
  'organizer_executive_name',
  'organizer_executive_role',
  'buyer_name',
  'seller_name',
  'participant_name',
  'debtor_arbitration_court',
  'debtor_case_act_court',
  'debtor_manager_act_court',
  'kommersant_party_name'
];

// Переменные, для которых нужен выбор падежа (не ФИО)
export const DECLENSION_VARIABLES = [
  'debtor_case_act_type',
  'debtor_manager_act_type',
  'debtor_manager_role',
  'deposit_account_owner_type_label',
  'payment_account_owner_type_label'
];

export const DATE_VARIABLES = [
  'contract_date',
  'current_date',
  'agreement_date',
  'debtor_case_act_date',
  'debtor_manager_act_date'
];

export const DATETIME_VARIABLES = [
  'auction_date',
  'auction_start_datetime',
  'application_start_datetime',
  'results_datetime',
  'application_deadline'
];

export const DATE_FORMAT_OPTIONS = [
  {
    id: 'default',
    suffix: '',
    label: '31.12.2024',
    description: 'DD.MM.YYYY'
  },
  {
    id: 'long',
    suffix: '_long',
    label: '31 декабря 2024',
    description: 'DD месяц YYYY'
  },
  {
    id: 'iso',
    suffix: '_iso',
    label: '2024-12-31',
    description: 'ISO 8601 (YYYY-MM-DD)'
  }
];

export const DATETIME_FORMAT_OPTIONS = [
  {
    id: 'default',
    suffix: '',
    label: '31.12.2024 14:30',
    description: 'DD.MM.YYYY HH:MM'
  },
  {
    id: 'long',
    suffix: '_long',
    label: '31 декабря 2024 14:30',
    description: 'DD месяц YYYY HH:MM'
  },
  {
    id: 'date',
    suffix: '_date',
    label: '31.12.2024',
    description: 'Только дата'
  },
  {
    id: 'date_long',
    suffix: '_date_long',
    label: '31 декабря 2024',
    description: 'Только дата (длинный формат)'
  },
  {
    id: 'time',
    suffix: '_time',
    label: '14:30',
    description: 'Только время'
  },
  {
    id: 'time_words',
    suffix: '_time_words',
    label: '14 часов 30 минут',
    description: 'Только время (словами)'
  },
  {
    id: 'time_short',
    suffix: '_time_short',
    label: '14 ч. 30 мин.',
    description: 'Только время (коротко)'
  }
];

export default TEMPLATE_VARIABLES;
